var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recommended-product-benefit-container",class:_vm.selectedIndex === _vm.index ? 'hover' : '',on:{"mouseover":_vm.handleMouseOver,"mouseleave":_vm.handleMouseLeave,"click":_vm.benefitSelected}},[_c('p',[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }